<template>
  <div class="news">
    <div class="banner">
      <div class="img">
        <img :src="this.$store.getters.banner[this.$route.path]" />
      </div>
      <div class="menu">
        <van-tabs v-model="active">
          <van-tab title="新闻动态">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height: 100vh;">
              <van-list v-model="loading" :finished="finished" @load="onLoad">
                <template v-for="(item, index) in list">
                  <div class="list" :key="index">
                    <a :href="getHref(item.id, item.category)">
                      <div class="content">
                        <div class="img">
                          <img
                            class="van-image__img"
                            data-src="../../../assets/search2.jpg"
                            :src="item.firstPhoto"
                            lazy="loaded"
                            style="object-fit: cover;"
                          />
                        </div>
                        <div class="title">
                          {{ item.title }}
                        </div>
                      </div>
                      <p class="time">{{ item.createDate }} ｜ 浏览 {{ item.browserCount }}</p>
                    </a>
                  </div>
                </template>
              </van-list>
            </van-pull-refresh>
          </van-tab>
          <van-tab title="行业百科">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height: 100vh;">
              <van-list v-model="loading" :finished="finished" @load="onLoad">
                <template v-for="(item, index) in list">
                  <div class="list" :key="index">
                    <a :href="getHref(item.id, item.category)">
                      <div class="content">
                        <div class="img">
                          <img
                            class="van-image__img"
                            data-src="../../../assets/search2.jpg"
                            :src="item.firstPhoto"
                            lazy="loaded"
                            style="object-fit: cover;"
                          />
                        </div>
                        <div class="title">
                          {{ item.title }}
                        </div>
                      </div>
                      <p class="time">{{ item.createDate }} ｜ 浏览 {{ item.browserCount }}</p>
                    </a>
                  </div>
                </template>
              </van-list>
            </van-pull-refresh>
          </van-tab>
          <van-tab title="客户须知">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height: 100vh;">
              <van-list v-model="loading" :finished="finished" @load="onLoad">
                <template v-for="(item, index) in list">
                  <div class="list" :key="index">
                    <a :href="getHref(item.id, item.category)">
                      <div class="content">
                        <div class="img">
                          <img
                            class="van-image__img"
                            data-src="../../../assets/search2.jpg"
                            :src="item.firstPhoto"
                            lazy="loaded"
                            style="object-fit: cover;"
                          />
                        </div>
                        <div class="title">
                          {{ item.title }}
                        </div>
                      </div>
                      <p class="time">{{ item.createDate }} ｜ 浏览 {{ item.browserCount }}</p>
                    </a>
                  </div>
                </template>
              </van-list>
            </van-pull-refresh></van-tab
          >
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../../../common/bus'
export default {
  name: 'newsIndex',
  components: {},
  data() {
    return {
      active: 0,
      code: 'news',
      isLoading: false,
      loading: false,
      finished: false,
      page: 1,
      list: [],
    }
  },
  created() {
    this.active = this.$route.params.type
    if (this.active == 0) {
      this.code = 'news'
      this.page = 1
      this.list = []
      bus.$emit('path', 'xwdt')
    } else if (this.active == 1) {
      this.code = 'industry'
      this.page = 1
      this.list = []
      bus.$emit('path', 'hybk')
    } else if (this.active == 2) {
      this.code = 'notice'
      this.page = 1
      this.list = []
      bus.$emit('path', 'khxz')
    }
    this.getData()
  },
  methods: {
    getHref(id, category) {
      return '/newsDetail/' + category.value + '/' + id
    },
    getData() {
      var that = this
      this.$queryPage(
        'OweDynamic',
        { category: that.code, page: that.page, size: 10, sort: { browserCount: 0 } },
        ['id,category,title,firstPhoto,createDate,browserCount'],
        function(res) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              that.list.push(item)
            })
            that.loading = false
            that.page++
          } else {
            that.finished = true
            that.loading = false
            that.isLoading = false
            that.$notify({
              message: '没有更多数据啦~',
              color: '#ad0000',
              background: '#ffe1e1',
            })
          }
        }
      )
    },
    onLoad() {
      let that = this
      setTimeout(() => {
        if (that.isLoading) {
          that.isLoading = false
        }
        this.getData()
      }, 500)
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.onLoad()
    },
  },
  watch: {
    $route() {
      if (this.active != this.$route.params.type) {
        this.active = this.$route.params.type
      }
    },
    active() {
      if (this.active == 0) {
        this.code = 'news'
        this.page = 1
        this.list = []
        bus.$emit('path', 'xwdt')
      } else if (this.active == 1) {
        this.code = 'industry'
        this.page = 1
        this.list = []
        bus.$emit('path', 'hybk')
      } else if (this.active == 2) {
        this.code = 'notice'
        this.page = 1
        this.list = []
        bus.$emit('path', 'khxz')
      }
      this.getData()
    },
  },
}
</script>

<style>
.news .banner {
}
.news .banner .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.news .banner .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.news .banner .menu {
}
.news .van-tabs__wrap .van-tabs__nav .van-tab {
  font-size: 0.37333rem;
  color: #333;
}
.news .van-tabs__wrap .van-tabs__nav .van-tab--active {
  color: #dea767;
  font-weight: 400;
}
.news .van-tabs__line {
  background-color: #dea767;
}
.news .van-tabs__content {
  padding: 0 0.4rem;
}
.news .list {
  padding: 0.67rem 0 0.27rem;
  border-bottom: 0.027rem solid #dfdfdf;
}
.news .menu .list .img {
  width: 100%;
  height: 3rem;
}
.news .menu .list .img img {
  width: 100%;
  border-radius: 5px;
}
.news .menu .list .title {
  font-size: 0.42667rem;

  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.13333rem;
  margin-top: 0.1rem;
}
.news .menu .list .time {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
}
.van-pull-refresh {
  height: calc(100vh-100px) !important;
  overflow: auto !important;
}
/* .new .img{
      width: 1.87rem;
    height: 1.87rem;
    flex-shrink: 0;
    margin-right: .26667rem;
    border-radius: .05333rem;
    overflow: hidden;
    

    position: relative;
    display: inline-block;
}
.news .content{
      max-width: 7.06667rem;
          font-size: .42667rem;
    font-weight: 500;
    color: #333;
    line-height: .61333rem;
    margin-bottom: .13333rem;
        overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
} */
</style>
